export const SEARCH_BY_FIELD = {
  NAME: 'name',
  PHONE: 'phone',
  EMAIL: 'email',
};
export const SEARCH_BY = [SEARCH_BY_FIELD.EMAIL, SEARCH_BY_FIELD.PHONE, SEARCH_BY_FIELD.NAME];

export const SEARCH_LEVEL = {
  GLOBAL: 'global',
  CLIENT_LIST: 'clientList',
};
